import { missingWidget } from '../utils/helpers';

export default function statsWidget() {
  const widgetName = 'statsWidget';
  const $widget = $(`#${widgetName}`);
  const $statsContainer = $('.stats-container');

  const widgetOpts = typeof statsWidgetOpts === 'undefined' ? null : statsWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 6,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    slideshow: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createSpinningNumbers(data);
      } else {
        $statsContainer.remove();
      }
    },
  });
  function createSpinningNumbers(data) {
    let countTo;

    $('<div class="sp-container animated"></div>').prependTo(`#${widgetName}`);
    $(`<div class="sp-wrapper"></div>`).appendTo('.sp-container');

    const items = data.items;

    let counter = 0;
    items.forEach(function (item) {
      let dividerElement = counter > 0 ? "<span class='divider'></span>" : '';
      const stat = `
      <div class="sp-block">
        <span class="sp-value">${item.Title}</span>
        <span class="spinning-text">${item.Description}</span>
        ${dividerElement}
      </div>`;
      $('.sp-wrapper').append(stat);
      counter++;
    });

    function animateNumbers(el) {
      countTo = el.attr('data-countNum');
      $({ countNum: el.text() }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 3000,
          easing: 'swing',
          step: function () {
            el.text(formatNumber(Math.floor(this.countNum)));
          },
          complete: function () {
            el.text(formatNumber(this.countNum));
          },
        },
      );
    }

    $(`#${widgetName} .sp-block`).each(function () {
      const $title = $(this).find('.sp-value');
      const $titleNumber = $title.find('span');
      const titleNumberNum = $title.find('span').text();
      $titleNumber.text('0');
      $titleNumber.addClass('js-countNum');
      $titleNumber.attr('data-countNum', titleNumberNum);
    });

    const $cw3 = $(`#${widgetName} .js-countNum`);
    const cw3top = $cw3.offset().top;
    let animated = false;
    const vpBtm = $(globalThis).scrollTop() + $(globalThis).height();

    function triggerAnimation(p) {
      if (cw3top < p && !animated) {
        $cw3.each(function () {
          animateNumbers($(this));
        });
        animated = true;
      }
    }

    triggerAnimation(vpBtm);

    $(globalThis).on('scroll', function () {
      const vpBtm = $(globalThis).scrollTop() + $(globalThis).height();
      triggerAnimation(vpBtm);
    });

    $(`#${widgetName} .card-widget-item`).remove();
  }
}

function formatNumber(num) {
  return num.toLocaleString();
}
